import { combineReducers } from "@reduxjs/toolkit";
import { AdminUserProfile, CaseSearchPage } from "@types-runway/admin";
import { Order } from "@types-runway/case";

import { createEntitySlice } from "./entitySlice";

// FIND — locate a customer's records. One entity per search the job offers,
// each the shape its endpoint returns (admin-dashboard-spec.md, Glossary):
//   user   GET user/search?email=        one profile, or null when no user matches
//   cases  GET /v1/search/case           one page: rows, total, hasMore
//   orders GET /order/search             up to 30 orders, newest first
// Results never cross entities (FIND-R2). The sagas that fill them arrive with
// each job's ticket; the reducers are the contract they write to. Their trigger
// actions (the ones that call the API) must then join src/store/crossTabBlacklist.ts
// so a second open tab does not repeat the request; these result actions may sync.
const emptyCaseSearchPage: CaseSearchPage = { rows: [], total: 0, hasMore: false };

export const userSearchSlice = createEntitySlice<AdminUserProfile | null>(
  "adminDashboard/find/user",
  null
);
export const caseSearchSlice = createEntitySlice<CaseSearchPage>(
  "adminDashboard/find/cases",
  emptyCaseSearchPage
);
export const orderSearchSlice = createEntitySlice<Order[]>("adminDashboard/find/orders", []);

export const userSearchActions = userSearchSlice.actions;
export const caseSearchActions = caseSearchSlice.actions;
export const orderSearchActions = orderSearchSlice.actions;

const findReducer = combineReducers({
  user: userSearchSlice.reducer,
  cases: caseSearchSlice.reducer,
  orders: orderSearchSlice.reducer,
});

export default combineReducers({
  find: findReducer,
});
